module.exports = __webpack_public_path__ + "static/img/14000503.dd52151f.png";